import { Reveal } from "@/components/Reveal";

const POINTS = ["Clear Scope", "Transparent Process", "Defined Specifications", "Customer Communication", "Progress Visibility"];
const PRINCIPLES = ["NO HIDDEN COST", "NO CONFUSION", "COMPLETE CLARITY"];

export const Transparency = () => (
    <section id="transparency" data-testid="transparency-section" className="relative overflow-hidden bg-omsivo-navy py-20 lg:py-28">
        <span aria-hidden className="text-outline-light pointer-events-none absolute -top-6 right-0 select-none font-display text-[16vw] font-black leading-none opacity-[0.06]">
            CLARITY
        </span>
        <div className="relative z-10 mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
            <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
                <div>
                    <Reveal>
                        <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.28em] text-flame">Transparency</p>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <h2 className="mt-4 font-display text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl lg:text-5xl">
                            Construction<br />with clarity.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.16}>
                        <div className="mt-8 flex flex-wrap gap-2.5">
                            {PRINCIPLES.map((p) => (
                                <span key={p} className="rounded-full border border-flame/50 bg-flame/10 px-5 py-2.5 font-display text-xs font-extrabold uppercase tracking-[0.14em] text-flame"
                                    data-testid={`principle-${p.toLowerCase().replace(/\s+/g, "-")}`}>
                                    {p}
                                </span>
                            ))}
                        </div>
                    </Reveal>
                </div>
                <div className="space-y-0 rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-sm">
                    {POINTS.map((p, i) => (
                        <Reveal key={p} delay={0.05 * i}>
                            <div className="flex items-center gap-5 border-b border-white/8 px-6 py-5 last:border-0" data-testid={`transparency-point-${i}`}>
                                <span className="font-mono text-[10px] text-flame">0{i + 1}</span>
                                <span className="font-display text-base font-bold uppercase tracking-[0.1em] text-white/90">{p}</span>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </div>
    </section>
);
